import { Component } from 'react'
import { StwReportQueryResult, DetailCell, StwOperation, StwOperationAction } from '../../../api'
import { AdvancedTableSortDirection } from '../../../components/AdvancedTable'
import { SkeletonAttributeReport } from '../../../constants'
import { KeyValueGrid, StylewherePage, NotFound, Section, DefaultHeader, TableListReport } from '../../../components'
import { showModal } from '../../../components/modalPageUtils'
import { __, T } from '../../../shared/i18n'
import { ExtendRouteComponentProps } from '../../../types'
import Operations from '../../../api/Operations'
import Reports from '../../../api/Reports'
import { getFragmentObject, getMultipleTitle, getBackURL, getHeaderOperationActions } from '../../../shared/utils'

interface State {
  reportInstance: StwReportQueryResult | undefined
  configuration: DetailCell[]
  loader: boolean
  operationInstanceId: string | undefined
  actions: StwOperationAction[]
}

export default class PickingOperationDetail extends Component<ExtendRouteComponentProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      reportInstance: undefined,
      configuration: [],
      loader: true,
      operationInstanceId: undefined,
      actions: [],
    }
  }

  componentDidMount = async () => {
    await this.initialize()
  }

  initialize = async () => {
    const { match } = this.props
    if (match && match.params && match.params.operationInstanceId) {
      const params = { operationId: match.params.operationId }
      const reportId = await Operations.getReportId(match.params.operationId)
      const instance: any = await Reports.reportInstance(reportId, match.params.operationInstanceId, params)
      if (instance && instance.id) {
        const operation: StwOperation = await Operations.get<StwOperation>(match.params.operationId)
        const configuration = await Reports.getConfiguration(reportId, params)
        this.setState({
          reportInstance: instance,
          operationInstanceId: match.params.operationInstanceId,
          configuration: configuration,
          loader: false,
          actions: operation && operation.actions && operation.actions !== null ? operation.actions : [],
        })
      } else {
        this.setState({
          loader: false,
        })
      }
    } else {
      this.setState({
        loader: false,
      })
    }
  }

  showDetail = (record: StwReportQueryResult) => {
    showModal({
      type: 'PICKING_ENTRY_READS',
      data: { pickingEntryId: record.id },
    })
  }

  render = () => {
    const { breadcrumbs, queryString, match } = this.props
    const { reportInstance, loader, configuration, operationInstanceId, actions } = this.state
    const fragment = getFragmentObject(reportInstance, 'id')
    return (
      <StylewherePage {...this.props} noOverflow fragment={fragment}>
        <DefaultHeader
          backPath={getBackURL(queryString, breadcrumbs)}
          multipleTitle={getMultipleTitle(reportInstance)}
          title={__(T.misc.not_found)}
          skeleton={{ active: loader, options: { multiple: true } }}
          actions={
            reportInstance
              ? getHeaderOperationActions(
                  'logistics',
                  'picking',
                  actions,
                  match.params.operationId,
                  match.params.operationInstanceId
                )
              : []
          }
        />
        <Section customClass={`stw-section-page paged-header ${reportInstance || loader ? 'scroll transparent' : ''}`}>
          {reportInstance || loader ? (
            <>
              <Section>
                <KeyValueGrid
                  skeleton={loader}
                  fields={loader ? SkeletonAttributeReport : configuration}
                  data={reportInstance}
                />
              </Section>
              {operationInstanceId && (
                <TableListReport
                  {...this.props}
                  reportId="OPLOG_PICKING_ENTRY"
                  operationId="OPLOG_PICKING_ENTRY"
                  actions={[]}
                  fixedTableHeight
                  disabledReportExport
                  headerType="boxed"
                  title={__('fields.labels.pickingEntries')}
                  customColumnPrefix="pickingDetailEntries"
                  reportActions={{
                    active: true,
                    onlyedit: false,
                    onClick: this.showDetail,
                    condition: 'pickedQuantity',
                  }}
                  reportParams={{ pickingId: operationInstanceId }}
                  sortValues={{ code: AdvancedTableSortDirection.asc }}
                  disableLocation
                />
              )}
            </>
          ) : (
            <NotFound fullheight title={__(T.misc.noRecordFoundTitle)} />
          )}
        </Section>
      </StylewherePage>
    )
  }
}
